export function isHidden(element) {
  return window.getComputedStyle(element).display === 'none' || element.offsetParent === null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/utils/dom/style.js
// module id = null
// module chunks = 